export default "__VITE_ASSET__26190d03__"